export default "__VITE_ASSET__CHWURDFU__"